import { useCallback, useContext, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Drawer, Menu as AntdMenu } from 'antd';
import Colors from 'components/tokens/Colors';
import 'antd/dist/antd.css';
import Text from 'components/atoms/Text';
import { spacing } from 'components/atoms/Grid/constants';
import { Col, Container, Row } from 'components/atoms/Grid';
import Link from 'components/atoms/Link';
import Icon from 'components/atoms/Icon';
import RouterLink from 'components/atoms/RouterLink';
import { useEditor } from 'providers/generalContext';
import { UserContext } from 'contexts';
import { useNavigate } from 'react-router-dom';

const { SubMenu } = AntdMenu;

// submenu keys of first level
const rootSubmenuKeys = ['sub1', 'sub2', 'sub3', 'sub4', 'sub5'];

export const MenuContainer = styled.div`
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    position: absolute;
    bottom: 0;
    top: ${({ visible }) => (visible ? '122px' : 0)};
    transform: ${({ visible }) => (visible ? 'none' : 'translateY(-110%)')};
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: center;
    background: ${Colors.black};
    border-radius: 2px;

    height: ${({ value }) => (value > 0 ? '100%' : 'auto')};

    .fadeEffect {
        animation: fadeIn 500ms;
    }

    .ant-menu-submenu-title > svg {
        transition: transform;
        transition-duration: 200ms;
    }

    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow,
    .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-expand-icon,
    .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
        color: ${Colors.primary};
    }
    .ant-menu-root.ant-menu-vertical,
    .ant-menu-root.ant-menu-vertical-left,
    .ant-menu-root.ant-menu-vertical-right,
    .ant-menu-root.ant-menu-inline,
    .ant-menu-light .ant-menu-item:hover,
    .ant-menu-light .ant-menu-item-active,
    .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
    .ant-menu-light .ant-menu-submenu-active,
    .ant-menu-light .ant-menu-submenu-title:hover {
        background: ${Colors.black};
        color: ${Colors.white};
    }

    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow {
        right: 18px;
    }

    .ant-menu-submenu-title {
        padding-left: 24px !important;
        padding-right: 24px;
        line-height: 0 !important;
    }

    .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
        height: 60px;
    }

    .ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content,
    .ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {
        overflow: unset;
    }

    .ant-menu-inline,
    .ant-menu-vertical,
    .ant-menu-vertical-left {
        border: none;
    }

    .ant-drawer-body {
        overflow: hidden;
    }

    .ant-menu-sub.ant-menu-inline {
        background-color: ${Colors.black};
    }

    .ant-menu-submenu-open {
        > div {
            margin-bottom: 40px;
        }
    }

    @media (max-width: 820px) {
        .not-open {
            display: none;
        }
    }
`;

export const SubmenuPrymary = styled.div`
    padding: ${5 * spacing}px ${3 * spacing}px;
    background: ${Colors.primary};
    width: 75%;
`;

export const WhiteSpaceForMenu = styled.div`
    background: ${Colors.white};
    width: 25%;
`;

export const SubmenuSecondary = styled.div`
    padding: ${5 * spacing}px ${2 * spacing}px;
    background: ${Colors.white};
    width: 70%;
    min-height: 270px;
`;

export const StyledDrawer = styled(Drawer)`
    position: absolute;
    width: 100%;

    .ant-drawer-content-wrapper {
        width: 100% !important;
        height: 100% !important;
    }

    .ant-drawer-body {
        > div {
            overflow-y: auto !important;
        }
    }
`;

const DesktopPrimaryContainer = ({ openKeys, setVisible }) => {
    const { isStoryblokEditor } = useEditor();

    const pathNewsletters = window.location.pathname === '/institucional/nossas-newsletters' ? true : false;

    const handleNewsletterNavigate = () => {
        if (pathNewsletters) {
            window.history.pushState('', '', '/');
            window.location.href = '/institucional/nossas-newsletters#intervalo';
        } else {
            window.location.href = '/institucional/nossas-newsletters#intervalo';
        }
    };

    switch (openKeys[0]) {
        case 'sub1':
            return (
                <Row className="fadeEffect" mt="12">
                    <Col size="12" mb="3" pl=" 3" text="left">
                        <Text heading4>Explore</Text>
                    </Col>
                    <Col size="12" mb="1" pl=" 3" text="left">
                        <RouterLink
                            $$editor={isStoryblokEditor}
                            to="/jornalismo/categoria/checagem"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Checagem
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $$editor={isStoryblokEditor}
                            to="/jornalismo/categoria/verificação"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Verificação
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $$editor={isStoryblokEditor}
                            to="/jornalismo/categoria/reportagem"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Reportagem
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $$editor={isStoryblokEditor}
                            to="/jornalismo/categoria/notícia"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Notícia
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/explicador"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Explicador
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="4" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/opinião"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Opinião
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/todas"
                            color={Colors.primary}
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                                Todos os conteúdos
                            </Text>
                        </RouterLink>
                    </Col>
                </Row>
            );
        case 'sub2':
            return (
                <Row className="fadeEffect" mt="12">
                    <Col size="12" mb="3" pl="3" text="left">
                        <Text heading4>Explore</Text>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink $editor={isStoryblokEditor} to="/educacao/achado" decoration="none" weight="normal">
                            <Text body1 onClick={() => setVisible(false)}>
                                Achado
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="4" pl="3" text="left">
                        <Link onClick={handleNewsletterNavigate} decoration="none" weight="normal">
                            <Text body1>Intervalo</Text>
                        </Link>
                    </Col>
                    <Col size="12" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/educacao/categoria/todas"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Todos os conteúdos
                            </Text>
                        </RouterLink>
                    </Col>
                </Row>
            );
        case 'sub3':
            return (
                <Row className="fadeEffect" mt="12">
                    <Col size="12" mb="3" pl="3" text="left">
                        <Text heading4>Explore</Text>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <Link
                            href="https://noepicentro.news/"
                            decoration="none"
                            weight="normal"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Text body1>No Epicentro</Text>
                        </Link>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <Link
                            href="https://open.spotify.com/show/3RlBFjJAwpDY37DwetOqpl?si=4d45f9c27a9e4e8a"
                            decoration="none"
                            weight="normal"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Text body1>Reflexo Podcast</Text>
                        </Link>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <Link
                            href="https://youtu.be/8vlWpWJkSnY"
                            decoration="none"
                            weight="normal"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Text body1>#SóQueNão</Text>
                        </Link>
                    </Col>
                    <Col size="12" mb="4" pl="3" text="left">
                        <Text body1>Duvido, Logo Penso</Text>
                    </Col>
                    <Col size="12" pl="3" text="left">
                        <RouterLink $editor={isStoryblokEditor} to="/projetos" decoration="none" weight="normal">
                            <Text body1>Todos os conteúdos</Text>
                        </RouterLink>
                    </Col>
                </Row>
            );
        case 'sub4':
            return (
                <Row className="fadeEffect" mt="12">
                    <Col size="12" mb="3" pl="3" text="left">
                        <Text heading4>Sobre a Lupa</Text>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink $editor={isStoryblokEditor} to="/institucional" decoration="none" weight="normal">
                            <Text body1 onClick={() => setVisible(false)}>
                                Quem somos
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/institucional/2015/10/15/como-fazemos-nossas-checagens"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Nossa metodologia
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/institucional/2015/10/15/na-lupa-ha-espaco-para-contestacoes-e-correcoes"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Política de correção
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/institucional/categoria/acontecendo-na-lupa"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Acontecendo na Lupa
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="4" pl="3" text="left">
                        <Link
                            href={`https://us16.list-manage.com/contact-form?u=5f96cd3a5387a5865ae0d475f&form_id=8887ecbfa17653844d3a745701c1ee94`}
                            decoration="none"
                            weight="normal"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Text body1>Contato</Text>
                        </Link>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/institucional/nossas-newsletters"
                            decoration="none"
                            weight="normal"
                        >
                            <Text color={Colors.black} body1 onClick={() => setVisible(false)}>
                                Nossas newsletters
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" pl="3" text="left">
                        <Link
                            href="https://piaui.folha.uol.com.br/"
                            decoration="none"
                            weight="normal"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Text body1>revista piauí</Text>
                        </Link>
                    </Col>
                </Row>
            );
        case 'sub5':
            return (
                <Row className="fadeEffect" mt="12">
                  <Col size="12" mb="3" pl="3" text="left">
                      <Text heading4>Explore</Text>
                  </Col>
                  <Col size="12" mb="1" pl="3" text="left">
                      <RouterLink $editor={isStoryblokEditor} to="/sera-que-e-golpe" decoration="none" weight="normal">
                          <Text body1 onClick={() => setVisible(false)}>
                              Será que é Golpe?
                          </Text>
                      </RouterLink>
                  </Col>
                  <Col size="12" mb="1" pl="3" text="left">
                    <Link
                        href="https://www.youtube.com/watch?v=fMaOiVsub9Y"
                        color={Colors.primary}
                        decoration="none"
                        weight="normal"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                          8 de Janeiro
                        </Text>
                    </Link>
                  </Col>
                  <Col size="12" mb="1" pl="3" text="left">
                    <Link
                        href="https://lupa.uol.com.br/lupa-mapa-leis-desinformacao/"
                        color={Colors.primary}
                        decoration="none"
                        weight="normal"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                            LupaMundi
                        </Text>
                    </Link>
                  </Col>
                  <Col size="12" mb="1" pl="3" text="left">
                      <Link
                          href="https://noepicentro.news/"
                          color={Colors.primary}
                          decoration="none"
                          weight="normal"
                          target="_blank"
                          rel="noopener noreferrer"
                      >
                          <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                              No Epicentro
                          </Text>
                      </Link>
                  </Col>
                  <Col size="12" mb="1" pl="3" text="left">
                    <Link
                        href="https://lupa.uol.com.br/portfolio/diabetes-entenda-a-diferenca-entre-os-tipos-e-conheca-causas-e-tratamentos"
                        color={Colors.primary}
                        decoration="none"
                        weight="normal"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                          Obesidade e Diabetes
                        </Text>
                    </Link>
                  </Col>
                </Row>
            );

        default:
            return null;
    }
};

const DesktopSecondaryContainer = ({ openKeys, setVisible }) => {
    const { isStoryblokEditor } = useEditor();

    switch (openKeys[0]) {
        case 'sub1':
            return (
                <Row className="fadeEffect" mt="12">
                    <Col size="12" mb="3" pl="3" text="left">
                        <Text heading4>Assuntos</Text>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/política"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Política
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/eleições"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Eleições
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/saúde"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Saúde
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/ciência"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Ciência
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/meio-ambiente"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Meio Ambiente
                            </Text>
                        </RouterLink>
                    </Col>
                    <Col size="12" mb="1" pl="3" text="left">
                        <RouterLink
                            $editor={isStoryblokEditor}
                            to="/jornalismo/categoria/verificação"
                            decoration="none"
                            weight="normal"
                        >
                            <Text body1 onClick={() => setVisible(false)}>
                                Nas Redes
                            </Text>
                        </RouterLink>
                    </Col>
                </Row>
            );
        case 'sub2':
            return null;
        case 'sub3':
            return (
                <Row className="fadeEffect" mt="12">
                    <Col size="11" mb="3" text="left" pl="3">
                        <Text heading4>Programa de Membros</Text>
                    </Col>
                    <Col size="12" mb="1" text="left" pl="3">
                        <Text body1>
                            Faça parte do{' '}
                            <RouterLink
                                $editor={isStoryblokEditor}
                                to="/contexto"
                                fontSize="16"
                                lineHeihgt="21"
                                decoration="none"
                            >
                                Contexto
                            </RouterLink>
                        </Text>
                    </Col>
                    <Col size="12" mb="1" text="left" pl="3">
                        <Text body1>Já é membro?</Text>
                    </Col>
                    <Col size="12" mb="1" text="left" pl="3">
                        <RouterLink $editor={isStoryblokEditor} to="/login" decoration="none">
                            <Text body1 highlight underline>
                                Entrar
                            </Text>
                        </RouterLink>
                    </Col>
                </Row>
            );
        case 'sub4':
            return (
                <Row className="fadeEffect" mt="12">
                    <Col size="12" mb="3" text="left" pl="3">
                        <Text heading4>Participe</Text>
                    </Col>
                    <Col size="12" mb="1" text="left" pl="3">
                        <Link
                            href={`https://api.whatsapp.com/send/?phone=5521991933751&text&app_absent=0`}
                            decoration="none"
                            weight="normal"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Text body1>Sugestão de checagem</Text>
                        </Link>
                    </Col>
                    <Col size="12" mb="4" text="left" pl="3">
                        <Link
                            href="https://docs.google.com/forms/d/1XT4a5dR4kdEPZoBzSP-JLNa_BOLDh291SPowqyjnqRo/viewform?edit_requested=true"
                            decoration="none"
                            weight="normal"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Text body1>Quero ser um checador</Text>
                        </Link>
                    </Col>
                </Row>
            );
        case 'sub5':
            return null;

        default:
            return null;
    }
};

const StyledTitle = styled(Text)`
    transition: color 400ms;

    @media (min-width: 820px) {
        font-size: 6.4rem;
        white-space: nowrap;
    }

    @media (min-width: 980px) {
        font-size: 7.2rem;
    }
`;

const SubMenuContainer = styled.div`
    display: flex;
    height: 100%;
`;

const SubMenuContainerPrimary = styled.div`
    background: ${Colors.primary};
    width: 0;
    transition: width 200ms;

    ${({ openKeys }) => {
        switch (openKeys[0]) {
            case 'sub1':
                return css`
                    width: 50%;
                `;
            case 'sub2':
                return css`
                    width: 65%;
                `;
            case 'sub3':
                return css`
                    width: 50%;
                `;
            case 'sub4':
                return css`
                    width: 40%;
                `;
            case 'sub5':
                return css`
                    width: 65%;
                `;
            default:
                return null;
        }
    }};
`;

const SubMenuContainerSecondary = styled.div`
    background: ${Colors.white};
    width: 0;
    transition: width 200ms;
    ${({ openKeys }) => {
        switch (openKeys[0]) {
            case 'sub1':
                return css`
                    width: 50%;
                `;
            case 'sub2':
                return css`
                    width: 35%;
                `;
            case 'sub3':
                return css`
                    width: 50%;
                `;
            case 'sub4':
                return css`
                    width: 60%;
                `;
            case 'sub5':
                return css`
                    width: 40%;
                `;
            default:
                return null;
        }
    }};
`;

const DesktopMenu = ({ openKeys, onOpenChange, setVisible }) => {
    const { isStoryblokEditor } = useEditor();

    return (
        <Container style={{ height: '100%' }}>
            <Row alignItems="stretch" style={{ height: '100%' }}>
                <Col size="5" pl="1.5 4">
                    <Row>
                        <Col
                            size="12"
                            mb="1"
                            text="left"
                            pt="12"
                            onMouseEnter={() => onOpenChange([...openKeys, 'sub1'])}
                        >
                            <RouterLink $editor={isStoryblokEditor} to="/jornalismo" weight="normal" decoration="none">
                                <StyledTitle
                                    key="sub1"
                                    heading2
                                    color={openKeys[0] === 'sub1' ? Colors.primary : Colors.white}
                                    onClick={() => setVisible(false)}
                                >
                                    Jornalismo
                                </StyledTitle>
                            </RouterLink>
                        </Col>
                        <Col size="12" mb="1" text="left" onMouseEnter={() => onOpenChange([...openKeys, 'sub2'])}>
                            <RouterLink $editor={isStoryblokEditor} to="/educacao" weight="normal" decoration="none">
                                <StyledTitle
                                    key="sub2"
                                    heading2
                                    color={openKeys[0] === 'sub2' ? Colors.primary : Colors.white}
                                    onClick={() => setVisible(false)}
                                >
                                    Educação
                                </StyledTitle>
                            </RouterLink>
                        </Col>
                        {/* <Col size="12" mb="1" text="left" onMouseEnter={() => onOpenChange([...openKeys, 'sub3'])}>
                            <RouterLink $editor={isStoryblokEditor} to="/projetos" weight="normal" decoration="none">
                                <StyledTitle
                                    key="sub3"
                                    heading2
                                    color={openKeys[0] === 'sub3' ? Colors.primary : Colors.white}
                                >
                                    Especiais
                                </StyledTitle>
                            </RouterLink>
                        </Col> */}
                        <Col size="12" mb="1" text="left" onMouseEnter={() => onOpenChange([...openKeys, 'sub4'])}>
                            <RouterLink
                                $editor={isStoryblokEditor}
                                to={'/institucional'}
                                weight="normal"
                                decoration="none"
                            >
                                <StyledTitle
                                    key="sub4"
                                    heading2
                                    color={openKeys[0] === 'sub4' ? Colors.primary : Colors.white}
                                    onClick={() => setVisible(false)}
                                >
                                    Institucional
                                </StyledTitle>
                            </RouterLink>
                        </Col>
                        <Col size="12" mb="1" text="left" onMouseEnter={() => onOpenChange([...openKeys, 'sub5'])}>
                            <RouterLink $editor={isStoryblokEditor} to="/portfolio" weight="normal" decoration="none">
                                <StyledTitle
                                    key="sub5"
                                    heading2
                                    color={openKeys[0] === 'sub5' ? Colors.primary : Colors.white}
                                    onClick={() => setVisible(false)}
                                >
                                    Portfólio
                                </StyledTitle>
                            </RouterLink>
                        </Col>
                    </Row>
                </Col>
                <Col size="7" pr="0">
                    <SubMenuContainer>
                        <SubMenuContainerPrimary openKeys={openKeys}>
                            <DesktopPrimaryContainer openKeys={openKeys} setVisible={setVisible} />
                        </SubMenuContainerPrimary>
                        <SubMenuContainerSecondary openKeys={openKeys}>
                            <DesktopSecondaryContainer openKeys={openKeys} setVisible={setVisible} />
                        </SubMenuContainerSecondary>
                    </SubMenuContainer>
                </Col>
            </Row>
        </Container>
    );
};

const CollapsedUserMenu = styled.div`
    position: absolute;
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    transition: height 200ms ease-out;
    height: ${({ isMemberOpen }) => (isMemberOpen ? '228px' : '0')};
    background-color: ${Colors.primary};
    padding-left: 24px;
    width: 100%;
`;

const StyledMemberItem = styled.div`
    width: 100%;
    padding-bottom: 16px;

    &:last-child {
        padding-top: 16px;
        padding-bottom: 40px;
    }
`;

const LoggedUserMenu = styled.div`
    display: ${({ isVisibleLogin }) => (isVisibleLogin ? 'flex' : 'none')};
    justify-content: space-between;
    align-items: center;
    padding: 24px 24px 40px 24px;
    background-color: ${Colors.primary};
    color: ${Colors.black};
    position: absolute;
    transition: all 200ms ease-out;
    bottom: ${({ isMemberOpen }) => (isMemberOpen ? '228px' : '0')};
    width: calc(100% - 32px);
`;

const MemberMenuContainer = styled.div`
    display: ${({ isVisibleLogin }) => (isVisibleLogin ? 'flex' : 'none')};
    transition: display 300ms;
    transition-delay: 300ms;
    align-items: center;
    justify-content: space-between;
    color: ${Colors.white};
    position: absolute;
    padding: 0 24px;
    bottom: 40px;
    width: calc(100% - 32px);

    a {
        text-align: left;
        text-decoration: none;
        color: inherit;
        display: inline-flex;
        align-items: center;
    }

    .icon {
        height: 100%;
        padding-top: 12px;
        padding-bottom: 12px;
        padding-right: 12px;
        line-height: 0;
    }
`;

const MemberMenuMobile = ({ isVisibleLogin, user, isMemberOpen, setIsMemberOpen, onSetVisible }) => {
    const navigate = useNavigate();

    if (user) {
        return (
            <>
                <LoggedUserMenu
                    isVisibleLogin={isVisibleLogin}
                    isMemberOpen={isMemberOpen}
                    onClick={() => setIsMemberOpen(!isMemberOpen)}
                >
                    <Text heading4>{user?.name?.split(' ')[0]}</Text>
                    <Icon
                        name="ArrowDown"
                        style={{ transform: isMemberOpen ? 'rotate(180deg)' : undefined }}
                        color={Colors.black}
                    />
                </LoggedUserMenu>
                <CollapsedUserMenu isMemberOpen={isMemberOpen} onClick={() => setIsMemberOpen(false)}>
                    <StyledMemberItem
                        onClick={() => {
                            onSetVisible(false);
                            setIsMemberOpen(false);
                            navigate('/contexto');
                        }}
                    >
                        <Text body2 highlight color={Colors.black}>
                            Página inicial
                        </Text>
                    </StyledMemberItem>
                    <StyledMemberItem
                        onClick={() => {
                            onSetVisible(false);
                            setIsMemberOpen(false);
                            navigate('/contexto/configuracoes', { state: { selected: 'editUser' } });
                        }}
                    >
                        <Text body2 highlight color={Colors.black}>
                            Conta
                        </Text>
                    </StyledMemberItem>
                    {user?.payment_method === 'credit_card' || user?.payment_method === 'pix' ? (
                        <StyledMemberItem
                            onClick={() => {
                                onSetVisible(false);
                                setIsMemberOpen(false);
                                navigate('/contexto/configuracoes', { state: { selected: 'editPlan' } });
                            }}
                        >
                            <Text body2 highlight color={Colors.black}>
                                Assinatura
                            </Text>
                        </StyledMemberItem>
                    ) : null}
                    {user?.active_plan === 'basic' && user?.payment_method !== 'pix' && (
                        <StyledMemberItem
                            onClick={() => {
                                onSetVisible(false);
                                setIsMemberOpen(false);
                                navigate('/contexto/planos', { state: { selected: 'planos' } });
                            }}
                        >
                            <Text body2 highlight color={Colors.black}>
                                Assine
                            </Text>
                        </StyledMemberItem>
                    )}
                    <StyledMemberItem
                        onClick={() => {
                            onSetVisible(false);
                            setIsMemberOpen(false);
                            navigate('/contexto/configuracoes', { state: { selected: 'faq' } });
                        }}
                    >
                        <Text body2 highlight color={Colors.black}>
                            Perguntas frequentes
                        </Text>
                    </StyledMemberItem>
                    <StyledMemberItem
                        onClick={e => {
                            e.preventDefault();
                            navigate('/login', { state: { logout: true } });
                        }}
                    >
                        <Text body2 color={Colors.grey}>
                            Sair
                        </Text>
                    </StyledMemberItem>
                </CollapsedUserMenu>
            </>
        );
    }

    return (
        <MemberMenuContainer isVisibleLogin={isVisibleLogin}>
            <a href="/login">
                <span className="icon">
                    <Icon name="People" color={Colors.white} />
                </span>
                <Text body>Entrar</Text>
            </a>
            <a href="/contexto" className="textRight">
                <Text body2 highlight>
                    Seja membro
                </Text>
            </a>
        </MemberMenuContainer>
    );
};

export default function Menu({ visible, onSetVisible }) {
    const [openKeys, setOpenKeys] = useState([]);
    const [isMemberOpen, setIsMemberOpen] = useState(false);
    const { isStoryblokEditor } = useEditor();
    const { user } = useContext(UserContext);

    const setVisible = useCallback(
        visible => {
            onSetVisible && onSetVisible(visible);
        },
        [onSetVisible]
    );

    const onOpenChange = keys => {
        const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    useEffect(() => {
        if (!visible) {
            setOpenKeys([]);
        }
    }, [visible]);

    useEffect(() => {
        if (openKeys?.length) {
            setIsMemberOpen(false);
        }
    }, [openKeys]);

    const pathNewsletters = window.location.pathname === '/institucional/nossas-newsletters' ? true : false;

    const handleNewsletterNavigate = () => {
        if (pathNewsletters) {
            window.history.pushState('', '', '/');
            window.location.href = '/institucional/nossas-newsletters#intervalo';
        } else {
            window.location.href = '/institucional/nossas-newsletters#intervalo';
        }
    };

    return (
        <MenuContainer visible={visible} value={openKeys?.length > 0 ? 1 : 0}>
            <StyledDrawer
                placement="top"
                closable={false}
                visible={visible}
                getContainer={false}
                bodyStyle={{ padding: 0, background: Colors.black }}
            >
                <Row style={{ height: '100%', overflowY: 'hidden' }}>
                    <Col size="12 hidden">
                        <AntdMenu className="mobileMenu" mode="inline" openKeys={openKeys} onOpenChange={onOpenChange}>
                            <SubMenu
                                className={openKeys?.length > 0 && openKeys[0] !== 'sub1' ? 'not-open' : ''}
                                key="sub1"
                                style={{ marginTop: 40 }}
                                expandIcon={
                                    <Icon
                                        name="ArrowDown"
                                        style={{ transform: openKeys[0] === 'sub1' ? 'rotate(180deg)' : undefined }}
                                        color={Colors.primary}
                                    />
                                }
                                title={
                                    <Text title size="48" color={Colors.white}>
                                        Jornalismo
                                    </Text>
                                }
                            >
                                <Row alignItems="stretch">
                                    <SubmenuPrymary>
                                        <Row>
                                            <Col size="12" mb="2" px="2">
                                                <Text heading5>Explore</Text>
                                            </Col>
                                            <Col size="12" mb=".5" px="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/jornalismo/categoria/checagem"
                                                    weight="normal"
                                                    decoration="none"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Checagem
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" px="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/jornalismo/categoria/verificação"
                                                    weight="normal"
                                                    decoration="none"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Verificação
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" px="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/jornalismo/categoria/reportagem"
                                                    weight="normal"
                                                    decoration="none"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Reportagem
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" px="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/jornalismo/categoria/notícia"
                                                    weight="normal"
                                                    decoration="none"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Notícia
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" px="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/jornalismo/categoria/explicador"
                                                    weight="normal"
                                                    decoration="none"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Explicador
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb="4" px="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/jornalismo/categoria/opinião"
                                                    weight="normal"
                                                    decoration="none"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Opinião
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" px="2" mb=".5">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/jornalismo"
                                                    color={Colors.primary}
                                                    weight="normal"
                                                >
                                                    <Text body2 color={Colors.black} onClick={() => setVisible(false)}>
                                                        Destaques
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" px="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/jornalismo/categoria/todas"
                                                    color={Colors.primary}
                                                    weight="normal"
                                                >
                                                    <Text body2 color={Colors.black} onClick={() => setVisible(false)}>
                                                        Todos os conteúdos
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                        </Row>
                                    </SubmenuPrymary>
                                    <WhiteSpaceForMenu />
                                </Row>
                                <SubmenuSecondary>
                                    <Row>
                                        <Col size="12" mb="2" px="1.5">
                                            <Text heading5>Assuntos</Text>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <RouterLink
                                                $editor={isStoryblokEditor}
                                                to="/jornalismo/categoria/política"
                                                weight="normal"
                                                decoration="none"
                                            >
                                                <Text body2 onClick={() => setVisible(false)}>
                                                    Política
                                                </Text>
                                            </RouterLink>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <RouterLink
                                                $editor={isStoryblokEditor}
                                                to="/jornalismo/categoria/eleições"
                                                weight="normal"
                                                decoration="none"
                                            >
                                                <Text body2 onClick={() => setVisible(false)}>
                                                    Eleições
                                                </Text>
                                            </RouterLink>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <RouterLink
                                                $editor={isStoryblokEditor}
                                                to="/jornalismo/categoria/saúde"
                                                weight="normal"
                                                decoration="none"
                                            >
                                                <Text body2 onClick={() => setVisible(false)}>
                                                    Saúde
                                                </Text>
                                            </RouterLink>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <RouterLink
                                                $editor={isStoryblokEditor}
                                                to="/jornalismo/categoria/ciência"
                                                weight="normal"
                                                decoration="none"
                                            >
                                                <Text body2 onClick={() => setVisible(false)}>
                                                    Ciência
                                                </Text>
                                            </RouterLink>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <RouterLink
                                                $editor={isStoryblokEditor}
                                                to="/jornalismo/categoria/meio-ambiente"
                                                weight="normal"
                                                decoration="none"
                                            >
                                                <Text body2 onClick={() => setVisible(false)}>
                                                    Meio Ambiente
                                                </Text>
                                            </RouterLink>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <RouterLink
                                                $editor={isStoryblokEditor}
                                                to="/jornalismo/categoria/verificação"
                                                decoration="none"
                                                weight="normal"
                                            >
                                                <Text body2 onClick={() => setVisible(false)}>
                                                    Nas Redes
                                                </Text>
                                            </RouterLink>
                                        </Col>
                                    </Row>
                                </SubmenuSecondary>
                            </SubMenu>
                            <SubMenu
                                className={openKeys?.length > 0 && openKeys[0] !== 'sub2' ? 'not-open' : ''}
                                key="sub2"
                                style={{ marginTop: 40 }}
                                expandIcon={
                                    <Icon
                                        name="ArrowDown"
                                        style={{ transform: openKeys[0] === 'sub2' ? 'rotate(180deg)' : undefined }}
                                        color={Colors.primary}
                                    />
                                }
                                title={
                                    <Text title size="48" color={Colors.white}>
                                        Educação
                                    </Text>
                                }
                            >
                                <Row alignItems="stretch">
                                    <SubmenuPrymary>
                                        <Row>
                                            <Col size="12" mb="2" pl="2">
                                                <Text heading5>Explore</Text>
                                            </Col>
                                            <Col size="12" pl="2" mb=".5">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/educacao"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Destaques
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/educacao/achado"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Achado
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb="4" pl="2">
                                                <Link
                                                    onClick={handleNewsletterNavigate}
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Intervalo
                                                    </Text>
                                                </Link>
                                            </Col>
                                            <Col size="12" pl="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/educacao/categoria/todas"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Todos os conteúdos
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                        </Row>
                                    </SubmenuPrymary>
                                    <WhiteSpaceForMenu />
                                </Row>
                                <SubmenuSecondary />
                            </SubMenu>
                            {/* <SubMenu
                                className={openKeys?.length > 0 && openKeys[0] !== 'sub3' ? 'not-open' : ''}
                                style={{ marginTop: 40 }}
                                key="sub3"
                                expandIcon={
                                    <Icon
                                        name="ArrowDown"
                                        style={{ transform: openKeys[0] === 'sub3' ? 'rotate(180deg)' : undefined }}
                                        color={Colors.primary}
                                    />
                                }
                                title={
                                    <Text title size="48" color={Colors.white}>
                                        Especiais
                                    </Text>
                                }
                            >
                                <Row alignItems="stretch">
                                    <SubmenuPrymary>
                                        <Row>
                                            <Col size="12" mb="2" pl="2">
                                                <Text heading5>Explore</Text>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/projetos"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2>Destaques</Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2">
                                                <Link
                                                    href="https://noepicentro.news/"
                                                    decoration="none"
                                                    weight="normal"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Text body2>No Epicentro</Text>
                                                </Link>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2">
                                                <Link
                                                    href="https://open.spotify.com/show/3RlBFjJAwpDY37DwetOqpl?si=4d45f9c27a9e4e8a
"
                                                    decoration="none"
                                                    weight="normal"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Text body2>Reflexo Podcast</Text>
                                                </Link>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2">
                                                <Link
                                                    href="https://youtu.be/8vlWpWJkSnY"
                                                    decoration="none"
                                                    weight="normal"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Text body2>#SóQueNão</Text>
                                                </Link>
                                            </Col>
                                            <Col size="12" mb="4" pl="2">
                                                <Text body2>Duvido, Logo Penso</Text>
                                            </Col>
                                            <Col size="12" pl="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/projetos/conteudos"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2>Todos os conteúdos</Text>
                                                </RouterLink>
                                            </Col>
                                        </Row>
                                    </SubmenuPrymary>
                                    <WhiteSpaceForMenu />
                                </Row>
                                <SubmenuSecondary>
                                    <Row>
                                        <Col size="12" mb="2" px="1.5">
                                            <Text heading5>Programa de Membros</Text>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <Text body2>
                                                Faça parte do{' '}
                                                <Link
                                                    href="/contexto/cadastro"
                                                    fontSize="16"
                                                    lineHeihgt="21.79"
                                                    decoration="none"
                                                >
                                                    Contexto
                                                </Link>
                                            </Text>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <Text body2>Já é membro?</Text>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <RouterLink
                                                $editor={isStoryblokEditor}
                                                to="/login"
                                                decoration="none"
                                                weight="normal"
                                            >
                                                <Text body2 highlight underline>
                                                    Entrar
                                                </Text>
                                            </RouterLink>
                                        </Col>
                                    </Row>
                                </SubmenuSecondary>
                            </SubMenu> */}
                            <SubMenu
                                className={openKeys?.length > 0 && openKeys[0] !== 'sub4' ? 'not-open' : ''}
                                key="sub4"
                                style={{ marginTop: 40 }}
                                expandIcon={
                                    <Icon
                                        name="ArrowDown"
                                        style={{ transform: openKeys[0] === 'sub4' ? 'rotate(180deg)' : undefined }}
                                        color={Colors.primary}
                                    />
                                }
                                title={
                                    <Text title size="48" color={Colors.white}>
                                        Institucional
                                    </Text>
                                }
                            >
                                <Row alignItems="stretch">
                                    <SubmenuPrymary>
                                        <Row>
                                            <Col size="12" mb="2" pl="2">
                                                <Text heading5>Sobre a Lupa</Text>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/institucional"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Quem somos
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/institucional/2015/10/15/como-fazemos-nossas-checagens"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Nossa metodologia
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/institucional/conteudos/2015/10/15/na-lupa-ha-espaco-para-contestacoes-e-correcoes"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Política de correção
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb=".5" pl="2" text="left">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/institucional/categoria/acontecendo-na-lupa"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text body2 onClick={() => setVisible(false)}>
                                                        Acontecendo na Lupa
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" mb="4" pl="2" text="left">
                                                <Link
                                                    href={`https://us16.list-manage.com/contact-form?u=5f96cd3a5387a5865ae0d475f&form_id=8887ecbfa17653844d3a745701c1ee94`}
                                                    decoration="none"
                                                    weight="normal"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Text body2>Contato</Text>
                                                </Link>
                                            </Col>

                                            <Col size="12" mb="1" pl="2">
                                                <RouterLink
                                                    $editor={isStoryblokEditor}
                                                    to="/institucional/nossas-newsletters"
                                                    decoration="none"
                                                    weight="normal"
                                                >
                                                    <Text color={Colors.black} body2 onClick={() => setVisible(false)}>
                                                        Nossas newsletters
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" pl="2">
                                                <Link
                                                    href="https://piaui.folha.uol.com.br/"
                                                    decoration="none"
                                                    weight="normal"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Text body2>revista piauí</Text>
                                                </Link>
                                            </Col>
                                        </Row>
                                    </SubmenuPrymary>
                                    <WhiteSpaceForMenu />
                                </Row>
                                <SubmenuSecondary>
                                    <Row>
                                        <Col size="12" mb="2" px="1.5">
                                            <Text heading5>Participe</Text>
                                        </Col>
                                        <Col size="12" mb=".5" px="1.5">
                                            <Link
                                                href={`https://api.whatsapp.com/send/?phone=5521991933751&text&app_absent=0`}
                                                decoration="none"
                                                weight="normal"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Text body2>Sugestão de checagem</Text>
                                            </Link>
                                        </Col>
                                        <Col size="12" mb="4" px="1.5">
                                            <Link
                                                href="https://docs.google.com/forms/d/1XT4a5dR4kdEPZoBzSP-JLNa_BOLDh291SPowqyjnqRo/viewform?edit_requested=true"
                                                decoration="none"
                                                weight="normal"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Text body2>Quero ser um checador</Text>
                                            </Link>
                                        </Col>
                                    </Row>
                                </SubmenuSecondary>
                            </SubMenu>
                            <SubMenu
                                className={openKeys?.length > 0 && openKeys[0] !== 'sub5' ? 'not-open' : ''}
                                key="sub5"
                                style={{ marginTop: 40 }}
                                expandIcon={
                                    <Icon
                                        name="ArrowDown"
                                        style={{ transform: openKeys[0] === 'sub5' ? 'rotate(180deg)' : undefined }}
                                        color={Colors.primary}
                                    />
                                }
                                title={
                                    <Text title size="48" color={Colors.white}>
                                       Portfólio
                                    </Text>
                                }
                            >
                                <Row alignItems="stretch">
                                    <SubmenuPrymary>
                                        <Row>
                                            <Col size="12" mb="2" pl="2">
                                                <Text heading5>Explore</Text>
                                            </Col>
                                            <Col size="12" pl="2" mb=".5">
                                                <RouterLink $editor={isStoryblokEditor} to="/sera-que-e-golpe" decoration="none" weight="normal">
                                                    <Text body1 onClick={() => setVisible(false)}>
                                                        Será que e Golpe?
                                                    </Text>
                                                </RouterLink>
                                            </Col>
                                            <Col size="12" pl="2" mb=".5">
                                              <Link
                                                  href="https://www.youtube.com/watch?v=fMaOiVsub9Y"
                                                  color={Colors.primary}
                                                  decoration="none"
                                                  weight="normal"
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                              >
                                                  <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                                                    8 de Janeiro
                                                  </Text>
                                              </Link>
                                            </Col>
                                            <Col size="12" pl="2" mb=".5">
                                              <Link
                                                  href="https://lupa.uol.com.br/lupa-mapa-leis-desinformacao/"
                                                  color={Colors.primary}
                                                  decoration="none"
                                                  weight="normal"
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                              >
                                                  <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                                                      LupaMundi
                                                  </Text>
                                              </Link>
                                            </Col>
                                            <Col size="12" pl="2" mb=".5">
                                                <Link
                                                    href="https://noepicentro.news/"
                                                    color={Colors.primary}
                                                    decoration="none"
                                                    weight="normal"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                                                        No Epicentro
                                                    </Text>
                                                </Link>
                                            </Col>
                                            <Col size="12" pl="2" mb=".5">
                                              <Link
                                                  href="https://lupa.uol.com.br/portfolio/diabetes-entenda-a-diferenca-entre-os-tipos-e-conheca-causas-e-tratamentos"
                                                  color={Colors.primary}
                                                  decoration="none"
                                                  weight="normal"
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                              >
                                                  <Text body1 color={Colors.black} onClick={() => setVisible(false)}>
                                                    Obesidade e Diabetes
                                                  </Text>
                                              </Link>
                                            </Col>
                                        </Row>
                                    </SubmenuPrymary>
                                    <WhiteSpaceForMenu />
                                </Row>
                                <SubmenuSecondary />
                            </SubMenu>
                            <MemberMenuMobile
                                isVisibleLogin={!openKeys?.length}
                                user={user}
                                isMemberOpen={isMemberOpen}
                                setIsMemberOpen={setIsMemberOpen}
                                onSetVisible={onSetVisible}
                            />
                        </AntdMenu>
                    </Col>
                    <Col size="hidden 12">
                        <DesktopMenu openKeys={openKeys} onOpenChange={onOpenChange} setVisible={setVisible} />
                    </Col>
                </Row>
            </StyledDrawer>
        </MenuContainer>
    );
}
